import { useCommunicationCategoryCounts } from '../../../../hooks/useCommunicationCategoryCounts';
import { CategoryBarRow, CategoryBarRowSkeleton } from './CategoryBarRow';

const CARD_CLASS = 'bg-white rounded-xl border border-gray-200 shadow-sm';
const WINDOW_DAYS = 30;
const SKELETON_ROW_COUNT = 5;

interface CommunicationsByCategoryCardProps {
    practiceId: string;
}

// The endpoint already sorts desc by count and omits zero-count categories -
// this only computes maxCount (for bar width) and renders, never re-sorts.
export function CommunicationsByCategoryCard({ practiceId }: CommunicationsByCategoryCardProps) {
    const { counts, isLoading } = useCommunicationCategoryCounts(practiceId, WINDOW_DAYS);
    const maxCount = counts.reduce((max, c) => Math.max(max, c.count), 0);

    return (
        <div className={CARD_CLASS}>
            <div className="flex items-center justify-between px-5 py-3 border-b border-gray-100">
                <h3 className="text-[15px] font-bold text-gray-800">Communications by category</h3>
                <span className="text-[11px] font-semibold text-gray-400 uppercase tracking-wide">
                    Last 30 days
                </span>
            </div>
            <div className="px-5 py-4">
                {isLoading ? (
                    <div className="flex flex-col gap-2.5">
                        {Array.from({ length: SKELETON_ROW_COUNT }).map((_, i) => (
                            <CategoryBarRowSkeleton key={i} />
                        ))}
                    </div>
                ) : counts.length === 0 ? (
                    <p className="text-sm text-gray-400 text-center py-4">
                        No communications in the last 30 days.
                    </p>
                ) : (
                    <div className="flex flex-col gap-2.5">
                        {counts.map((c) => (
                            <CategoryBarRow
                                key={c.category}
                                category={c.category}
                                count={c.count}
                                maxCount={maxCount}
                            />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
